import { useState } from 'react';
import ActivateDrawer from './ActivateDrawer';
import { useIntl } from 'react-intl';
import { Button } from 'antd';

const ActivateCard = () => {
  const { formatMessage: t } = useIntl();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Button onClick={() => setOpen(true)}>{t({ id: 'card.activate.title' })}</Button>
      <ActivateDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ActivateCard;
